<script setup>
import { ref } from 'vue'

const { locale } = useI18n()
const items = ref([])
const showProfileDialog = ref(false)
const itemType = ref('')

const showDialog = (currentItems, type) => {
  showProfileDialog.value = true
  items.value = currentItems
  itemType.value = type
}

defineExpose({
  showDialog,
  showProfileDialog
})
</script>

<template>
  <Dialog v-model:visible="showProfileDialog" :modal="true" :draggable="false" dismissableMask
    class="md:min-w-[450px] sm:min-w-[300px]" :header="itemType === 'producer' ? 'Productores' : 'Artistas'">
    <div class="flex flex-col relative gap-3">
      <NuxtLink :to="`/${locale}/${itemType}/${item.username}`" v-for="(item, itemIndex) in items" :key="itemIndex">
        <div class="flex gap-3 border border-gray-200 p-4 rounded-lg hover:bg-red-700 hover:text-white">
          <img class="rounded-full border-2 border-gray-100 w-8" :src="item.photo_url" :alt="item.username" />
          <CheckDecagramIcon v-if="item?.is_verified" class="absolute bottom-3 ml-5 w-[14px]" />
          <div>{{ item.name }}</div>
        </div>
      </NuxtLink>
    </div>
  </Dialog>
</template>
